import React, { useEffect, useState, useCallback } from 'react';
import DataTable from './DataTable';
import axiosInstance from '../utils/axiosInstance';
import { toast, ToastContainer } from 'react-toastify';

const CompletedRequests = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Veri çekme fonksiyonu - useCallback ile sarmaladık
  const fetchApprovedRequests = useCallback(async () => {
    try {
      // Not: Eğer /request/approved endpoint'i sadece onaylıları getiriyorsa .filter'a gerek kalmayabilir
      // Ancak güvenlik amacıyla filter ve mutlaka sıralama ekliyoruz.
      const response = await axiosInstance.get('/request/approved');
      
      const sortedData = response.data
        .filter(request => request.status === 'approved')
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Yeniden eskiye sıralama

      setData(sortedData);
      setLoading(false);
    } catch (error) {
      console.error("Onaylanan veriler çekilirken hata oluştu:", error);
      toast.error("Veriler yüklenemedi!");
      setLoading(false);
    }
  }, []);

  // Sayfa ilk açıldığında veriyi çek
  useEffect(() => {
    fetchApprovedRequests();
  }, [fetchApprovedRequests]);

  if (loading) return <div className="data-page-container"><p>Yükleniyor...</p></div>;

  return (
    <div className="page-content-wrapper">
      <ToastContainer theme="dark" position="top-right" />
      
      <DataTable
        title="Onaylanan Talepler"
        data={data}
        isPendingPage={false}      // İşlem butonlarını gizler
        isCompletedPage={true}     // Tamamlanan sayfa olduğunu belirtir
        fetchData={fetchApprovedRequests} // "Yenile" butonuna bu fonksiyonu bağlar
      />
    </div>
  );
};

export default CompletedRequests;